import rootReducer, { type combinedReducer } from '@/features';
import { configureStore } from '@reduxjs/toolkit';

export const setupStore = (preloadedState?: Partial<ReturnType<typeof rootReducer>>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) => {
      const middleware = getDefaultMiddleware({
        immutableCheck: { warnAfter: 128 },
        serializableCheck: false,
      });
      return middleware;
    },
  });
};

export const store = setupStore();
export const getStoreState = () => store.getState();

export type RootState = ReturnType<typeof combinedReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
